import React, { useCallback, useContext, useState } from 'react'
import CollapsibleContainer from '../CollapsibleContainer'
import LoadingSpinner from '../../../../elem/LoadingSpinner'
import { ReportingContext } from '../../../../wrappers/ReportingContext'
import ReportTable from '../table/ReportTable'
import ExpandToggleButton from '../../../widgets/shared/ExpandToggleButton'

const PreviewQuery = ({ reportPreview }) => {
    if (!reportPreview) return null

    return (
        <div className="content">
            {reportPreview.queryParts && (
                <div style={{ marginLeft: '1rem' }}>
                    {reportPreview.queryParts.map((part, idx) => (
                        <p className="ml-1" key={idx}>
                            {part}
                        </p>
                    ))}
                </div>
            )}

            {reportPreview.error && (
                <div
                    className="notification is-danger is-light"
                    style={{ marginTop: '1rem' }}
                >
                    <p className="has-text-weight-semibold label is-normal">
                        Error:
                    </p>
                    <pre
                        className="is-family-code has-text-danger"
                        style={{ whiteSpace: 'pre-wrap' }}
                    >
                        {reportPreview.error}
                    </pre>
                </div>
            )}
        </div>
    )
}

const PreviewData = ({
    reportPreview,
    loading,
    updateQueryParameters,
    queryParameters,
}) => {
    if (!reportPreview) return null

    if (reportPreview.error) {
        return (
            <div className="content has-text-danger">
                <p>
                    Unable to run query. Review the Preview Query tab for
                    details.
                </p>
            </div>
        )
    }

    return (
        <div className="content">
            {/* <div className="previewTableContainer"> */}
            <ReportTable
                data={reportPreview.data}
                loading={loading}
                updateQueryParameters={updateQueryParameters}
                queryParameters={queryParameters}
                hideHeader={true}
                hideColumnSettings={true}
            />
            {/* </div> */}
        </div>
    )
}

const PreviewTabs = ({ onChange, active }) => (
    <div className="tabs is-large">
        <ul>
            <li
                className={`${active === 'query' ? 'is-active' : ''}`}
                onClick={() => onChange('query')}
            >
                <a>
                    <span>Preview Query</span>
                </a>
            </li>
            <li
                className={`${active === 'results' ? 'is-active' : ''}`}
                onClick={() => onChange('results')}
            >
                <a>
                    <span>Preview Results</span>
                </a>
            </li>
        </ul>
    </div>
)

const Preview = () => {
    const { updateQueryParameters, queryParameters, reportPreview, loading } =
        useContext(ReportingContext)

    const [activeTab, setActiveTab] = useState('query')
    const [expandedTab, setExpandedTab] = useState(null)

    const isExpanded = expandedTab === activeTab

    const handleTabChange = useCallback((tab) => {
        setActiveTab(tab)
    }, [])

    const toggleExpand = () => {
        setExpandedTab((prev) => (prev === activeTab ? null : activeTab))
    }

    const renderTabContent = () => {
        switch (activeTab) {
            case 'query':
                return <PreviewQuery reportPreview={reportPreview} />
            case 'results':
                return (
                    <PreviewData
                        reportPreview={reportPreview}
                        loading={loading}
                        updateQueryParameters={updateQueryParameters}
                        queryParameters={queryParameters}
                    />
                )
            default:
                return null
        }
    }

    if (loading) {
        return <LoadingSpinner />
    }

    return (
        <CollapsibleContainer title="Preview">
            <div className="is-relative">
                <div
                    style={{
                        position: 'absolute',
                        top: '0',
                        right: '0',
                        zIndex: 10,
                    }}
                >
                    <ExpandToggleButton
                        isExpanded={isExpanded}
                        onToggle={toggleExpand}
                        tooltipId={'preview-expand'}
                    />{' '}
                </div>
                <div className="mb-3">
                    <PreviewTabs
                        onChange={handleTabChange}
                        active={activeTab}
                    />
                </div>
            </div>
            <div className="tab-content">{renderTabContent()}</div>

            {isExpanded && (
                <div
                    className="preview-fullscreen-overlay"
                    onClick={() => setExpandedTab(null)}
                >
                    <div
                        className="preview-fullscreen-content box"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="is-relative mb-3">
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '0',
                                    right: '0',
                                    zIndex: 10,
                                }}
                            >
                                <ExpandToggleButton
                                    isExpanded={true}
                                    onToggle={() => setExpandedTab(null)}
                                    tooltipId={'unpreview-expand'}
                                />
                            </div>
                            <strong>
                                {activeTab === 'query'
                                    ? 'Preview Query'
                                    : 'Preview Results'}
                            </strong>
                        </div>
                        {renderTabContent()}
                    </div>
                </div>
            )}
        </CollapsibleContainer>
    )
}

export default Preview
